import React,{useEffect} from 'react'
import { Editable, IconButton } from "@chakra-ui/react"
import { LuCheck, LuPencilLine, LuX } from "react-icons/lu"

export default function EditableText({ onSubmit,...props}){
    return (
        <Editable.Root defaultValue="Click to edit" {...props} onSubmit={onSubmit}>
            <Editable.Preview />
            <Editable.Input />
            <Editable.Control>
                <Editable.EditTrigger asChild>
                <IconButton color={"var(--cr-blue-1)"} variant="ghost" size="xs">
                    <LuPencilLine />
                </IconButton>
                </Editable.EditTrigger>
                <Editable.CancelTrigger asChild>
                <IconButton color={"red"} borderColor={"red"} variant="outline" size="xs">
                    <LuX />
                </IconButton>
                </Editable.CancelTrigger>
                <Editable.SubmitTrigger asChild>
                <IconButton color={"green"} borderColor={"green"} variant="outline" size="xs">
                    <LuCheck />
                </IconButton>
                </Editable.SubmitTrigger>
            </Editable.Control>
        </Editable.Root>
    )
}
